(function () {
  'use strict';

  var MODAL_SELECTOR = '[data-edm-modal]';
  var DESCRIPTION_SELECTOR = '[data-global-community-modal-description]';
  var WORD_SELECTOR = '[data-widow-word]';
  var SHORT_LAST_LINE_RATIO = 0.38;
  var resizeTimer = null;
  var rafId = null;

  function normalizeText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getOriginalText(element) {
    var stored = element.getAttribute('data-widow-raw-text');
    if (stored) return stored;

    var original = normalizeText(element.textContent);
    if (original) {
      element.setAttribute('data-widow-raw-text', original);
    }
    return original;
  }

  function setPlainText(element, text) {
    element.textContent = text;
  }

  function renderWords(element, words, bindLastTwo) {
    var html = '';
    var index;

    for (index = 0; index < words.length; index += 1) {
      if (bindLastTwo && index === words.length - 2) {
        html += '<span data-widow-word>' +
          escapeHtml(words[index]) +
          '&nbsp;' +
          escapeHtml(words[index + 1]) +
          '</span>';
        break;
      }

      html += '<span data-widow-word>' + escapeHtml(words[index]) + '</span>';

      if (index < words.length - 1) {
        html += ' ';
      }
    }

    element.innerHTML = html;
  }

  function getRenderedLines(element) {
    var words = Array.prototype.slice.call(element.querySelectorAll(WORD_SELECTOR));
    var lines = [];

    words.forEach(function (wordEl) {
      var rect = wordEl.getBoundingClientRect();
      var top = Math.round(rect.top);
      var currentLine = lines[lines.length - 1];

      if (!currentLine || Math.abs(currentLine.top - top) > 1) {
        lines.push({
          top: top,
          left: rect.left,
          right: rect.right,
          wordCount: 1
        });
        return;
      }

      currentLine.left = Math.min(currentLine.left, rect.left);
      currentLine.right = Math.max(currentLine.right, rect.right);
      currentLine.wordCount += 1;
    });

    return lines.map(function (line) {
      return {
        wordCount: line.wordCount,
        width: line.right - line.left
      };
    });
  }

  function shouldAdjustLines(lines) {
    if (!lines || lines.length < 2) return false;

    var previousLine = lines[lines.length - 2];
    var lastLine = lines[lines.length - 1];
    var ratio = previousLine.width > 0 ? lastLine.width / previousLine.width : 1;

    return lastLine.wordCount === 1 || ratio < SHORT_LAST_LINE_RATIO;
  }

  function improveWidowIfNeeded(element) {
    if (!element || element.offsetParent === null) return;

    var originalText = getOriginalText(element);
    var words = originalText ? originalText.split(' ') : [];

    if (!originalText || originalText.indexOf(' ') === -1 || words.length < 4) {
      setPlainText(element, originalText);
      return;
    }

    renderWords(element, words, false);
    var originalLines = getRenderedLines(element);

    if (!shouldAdjustLines(originalLines)) {
      setPlainText(element, originalText);
      return;
    }

    var originalLastLine = originalLines[originalLines.length - 1];
    var originalPrevLine = originalLines[originalLines.length - 2];
    var originalRatio = originalPrevLine.width > 0 ? originalLastLine.width / originalPrevLine.width : 1;

    renderWords(element, words, true);
    var adjustedLines = getRenderedLines(element);

    if (adjustedLines.length !== originalLines.length || adjustedLines.length < 2) {
      setPlainText(element, originalText);
      return;
    }

    var adjustedLastLine = adjustedLines[adjustedLines.length - 1];
    var adjustedPrevLine = adjustedLines[adjustedLines.length - 2];
    var adjustedRatio = adjustedPrevLine.width > 0 ? adjustedLastLine.width / adjustedPrevLine.width : 1;
    var improved = adjustedLastLine.wordCount > 1 && adjustedRatio > originalRatio;

    if (!improved) {
      setPlainText(element, originalText);
    }
  }

  function scheduleWidowFix() {
    var description = document.querySelector(DESCRIPTION_SELECTOR);
    if (!description) return;

    if (rafId) {
      window.cancelAnimationFrame(rafId);
    }

    rafId = window.requestAnimationFrame(function () {
      rafId = window.requestAnimationFrame(function () {
        improveWidowIfNeeded(description);
      });
    });
  }

  function observeModalVisibility() {
    var modal = document.querySelector(MODAL_SELECTOR);
    if (!modal || typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'hidden' && !modal.hidden) {
          scheduleWidowFix();
        }
      });
    });

    observer.observe(modal, {
      attributes: true,
      attributeFilter: ['hidden']
    });
  }

  function bindResizeHandler() {
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        var modal = document.querySelector(MODAL_SELECTOR);
        if (modal && !modal.hidden) {
          scheduleWidowFix();
        }
      }, 80);
    });
  }

  function initGlobalCommunityWidowControl() {
    observeModalVisibility();
    bindResizeHandler();

    var modal = document.querySelector(MODAL_SELECTOR);
    if (modal && !modal.hidden) {
      scheduleWidowFix();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGlobalCommunityWidowControl, { once: true });
  } else {
    initGlobalCommunityWidowControl();
  }
})();
